export default {"src":"/_next/static/media/facebook.00796322.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};